<template>
  <div class="text_a" :target="target" @click="handleClick">
    <div
      class="dv-border-box-2"
      style="
        width: 150px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        margin-right: 20px;
      "
    >
      <svg width="150" height="50" class="dv-border-svg-container">
        <polygon
          fill="transparent"
          points="7, 7 143, 7 143, 43 7, 43"
        ></polygon>
        <polyline
          points="2, 2 148 ,2 148, 48 2, 48 2, 2"
          stroke="#fff"
        ></polyline>
        <polyline
          points="6, 6 144, 6 144, 44 6, 44 6, 6"
          stroke="rgba(255, 255, 255, 0.6)"
        ></polyline>
        <circle cx="11" cy="11" r="1" fill="#fff"></circle>
        <circle cx="139" cy="11" r="1" fill="#fff"></circle>
        <circle cx="139" cy="39" r="1" fill="#fff"></circle>
        <circle cx="11" cy="39" r="1" fill="#fff"></circle>
      </svg>
      <div class="border-box-content" :style="{ fontSize: fontSize }">
        {{ title }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    href: {
      type: String,
      default: "",
    },
    target: {
      type: String,
      default: "_",
    },
    title: {
      type: String,
      default: "",
    },
  },
  computed: {
    fontSize() {
      return 16 / (this.title.length / 7) + "px";
    },
  },
  methods: {
    handleClick() {
      if (this.href) {
        window.open(this.href, this.target);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 100vw;
  height: 10vh;
  .title {
    color: white;
    font-size: 40px;
    font-weight: bold;
    padding-bottom: 16vh;
    background: linear-gradient(to right, #00f260, #e60505);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    img {
      width: 150px;
    }
  }
}
.text_a {
  color: #fff;
  text-decoration: none;
}
</style>
